<template>
    <span 
        v-bind:title="text" 
        v-bind:data-html="html"
        data-toggle="tooltip"
        class="fa fa-lg fa-info-circle">
    </span>
</template>

<script>
    import {autoInitializeTooltips as autoInitializeTooltipsMixin} from "../../Util/Mixins/tooltips";
    
    export default {
        name: "tooltip-circle",
        mixins: [autoInitializeTooltipsMixin],
        props: {
            text: {
                type: String,
                required: true
            },
            html: {
                type: Boolean,
                required: false,
                default: false
            }
        }
    }
</script>
